import React from 'react';
import classes from './Tabs.module.css';

import { IDirtyState, selectDirtyState, setDirtyState } from '../../../store/slices/auth';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  tabs: {
    tabName: string;
    tabIndex: number;
  }[];
  selectedTabIdx: number;
  setSelectedTabIdx: (value: number) => void;
};

const Tabs: React.FC<Props> = ({ tabs, selectedTabIdx, setSelectedTabIdx }) => {
  const { translations } = useTranslation();
  const dispatch = useAppDispatch();
  const isDirtyState = useAppSelector<IDirtyState>(selectDirtyState);

  return (
    <div className={classes.tabsContainer}>
      {tabs.map((tab) => (
        <div
          key={tab.tabIndex}
          className={`${classes.tab} ${selectedTabIdx === tab.tabIndex ? classes.selectedTab : ''}`}
          onClick={() => {
            if (!isDirtyState.isDirty) {
              setSelectedTabIdx(tab.tabIndex);
            } else dispatch(setDirtyState({ isDirty: true, isModalOpen: true, component: '' }));
          }}
        >
          {translations(tab.tabName)}
        </div>
      ))}
    </div>
  );
};

export { Tabs };
